import React from "react";
import { fmtEUR } from "./euros";

// Montants proposés quand le rav n'en a pas choisi (multiples de 18, « haï »).
const MONTANTS_PAR_DEFAUT = [18, 36, 54, 100, 180, 360, 540, 1000];

/**
 * Choix du montant d'un don libre (collecte « thermomètre ») : jusqu'à 8
 * montants proposés + un champ « Autre montant ». Le montant reste une
 * CHAÎNE (valeur du champ) : le parent la convertit à l'envoi.
 *
 * Sorti tel quel de la page campagne pour servir aussi à la future story.
 */
export default function ChoixMontant({ campaign, amount, setAmount }) {
  const suggestions = campaign.suggested_amounts && campaign.suggested_amounts.length > 0
    ? campaign.suggested_amounts
    : MONTANTS_PAR_DEFAUT;
  return (
    <div>
      <p className="text-[10px] uppercase tracking-[0.15em] text-stone-500 mb-3">
        Choisissez votre montant
      </p>
      <div className="grid grid-cols-4 gap-2 mb-3">
        {suggestions.slice(0, 8).map((s) => (
          <button key={s} type="button" onClick={() => setAmount(String(s))}
            className={`py-3 rounded-xl text-sm font-medium transition-colors ${
              amount === String(s)
                ? "bg-stone-900 text-white"
                : "bg-stone-50 text-stone-700 hover:bg-stone-100"
            }`}>
            {fmtEUR(s)}
          </button>
        ))}
      </div>
      <input type="number" value={amount} onChange={e => setAmount(e.target.value)}
        placeholder="Autre montant (€)" min="1"
        className="w-full px-3 py-3 rounded-xl border border-stone-200 text-base focus:outline-none focus:ring-2 focus:ring-stone-900/10" />
    </div>
  );
}
